import { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import useCleanTimeout from "src/hooks/useCleanTimeout";
import useHilosStore from "src/hooks/useHilosStore";

const AgentAvailabilityToggle = () => {
  const { t } = useTranslation();
  const { session, updateSession } = useHilosStore();
  const [isDisabled, setIsDisabled] = useState(false);
  const cleanTimeout = useCleanTimeout();

  const handleSetAvailibilityForInbox = useCallback(
    (nextVal) => {
      setIsDisabled(true);
      updateSession({
        is_available_for_inbox: nextVal,
      });
      cleanTimeout.current = setTimeout(() => {
        setIsDisabled(false);
      }, 1000);
    },
    [cleanTimeout, updateSession]
  );

  const isAvailable = session?.is_available_for_inbox;

  return (
    <div className="group flex items-center space-x-2">
      <button
        className={
          "flex items-center space-x-2 rounded-md p-1 hover:bg-gray-100 disabled:cursor-wait"
        }
        title={t(
          isAvailable
            ? t("inbox:available", "Available")
            : t("inbox:away", "Away")
        )}
        onClick={() =>
          handleSetAvailibilityForInbox(!session?.is_available_for_inbox)
        }
        disabled={isDisabled}
      >
        <span className="text-xs text-gray-500 group-hover:text-gray-700">
          {t(
            isAvailable
              ? t("inbox:available", "Available")
              : t("inbox:away", "Away")
          )}
        </span>
        <div
          className={`h-3 w-3 rounded-full transition-colors duration-200 ${
            isAvailable ? "bg-green-500" : "border-2 border-orange-400"
          }`}
        />
      </button>
    </div>
  );
};

export default AgentAvailabilityToggle;
